import cookie from 'cookie';
import qs from 'qs';

// taken from https://github.com/ljharb/qs/issues/91#issuecomment-437926409
export function parseQueryString(queryString: string) {
  return qs.parse(queryString, {
    decoder(str, decoder, charset) {
      const strWithoutPlus = str.replace(/\+/g, ' ');
      if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
      }

      if (/^(\d+|\d*\.\d+)$/.test(str)) {
        return parseFloat(str);
      }

      const keywords = {
        true: true,
        false: false,
        null: null,
        undefined,
      };
      if (str in keywords) {
        return keywords[str];
      }

      // utf-8
      try {
        return decodeURIComponent(strWithoutPlus);
      } catch (e) {
        return strWithoutPlus;
      }
    },
  });
}

interface MakeQueryStringOptions {
  url: string;
  params?: Record<string, any>;
  taxonomy?: Record<string, any>;
}

export function makeQueryString(options: MakeQueryStringOptions) {
  const url = options.url || '';
  const params = options.params || {};
  const taxonomy = options.taxonomy || {};

  const queryString = url.split('?')[1] || '';
  const query = {
    ...qs.parse(queryString),
    ...params,
    ...taxonomy,
  };

  const stringifiedQuery = qs.stringify(query);
  if (!stringifiedQuery) return url;

  const stub = url.toString().replace(/(\?.*)/, '');
  return `${stub}?${stringifiedQuery}`;
}

/**
 * Returns an object that mimics an express request object
 */
export const convertToServerRequest = (req) => {
  if (req?.get) return req;

  const serverRequest = {
    get: (name) => req.headers.get(name),
    cookies: cookie.parse(req?.headers?.get('cookie') ?? ''),
    ...req,
  };

  return serverRequest;
};
